export type GlobalMode = "GESTURE" | "TOUCH";

export const GlobalModeValues = {
  GESTURE: "GESTURE" as GlobalMode,
  TOUCH: "TOUCH" as GlobalMode,
};

export const saveMode = (mode: GlobalMode) => {
  localStorage.setItem("globalMode", mode);
};

export const getDefaultMode = (): GlobalMode => {
  const savedMode = localStorage.getItem("globalMode") as GlobalMode | null;
  return savedMode ?? GlobalModeValues.GESTURE;
};